import React from "react";
import { Row, Col, Button } from "antd";

const intl = {
  maxReached: {
    en: "Maximum peers responded to this evaluation",
    dk: "Maximalt antal besvarelser opnået"
  },
  submitText: {
    en: "Start you own evaluation",
    dk: "Start din egen selvevaluering"
  },
  contributing: {
    en: "Thanks for contributing to the evaluation of",
    dk: "Tak for dit bidrag til evalueringen af"
  },
  allSet: {
    en: "You are all set!",
    dk: "Alt er klart!"
  },
  gotoResult: {
    error: {
      en: "Evaluation ID is incorrect",
      dk: "Evaluerings ID er ikke korrekt"
    },
    continue: {
      en: "Go to result",
      dk: "Gå til resultat"
    }
  }
};

const getRedirectLink = (type, id) => {
  switch (type) {
    case "profile":
      return { redirectLink: `/profile/survey/${id}/results?step=REPORT` };
    case "twentyfivesections":
      return {
        redirectLink: `/twentyfivesections/survey/${id}/results?step=REPORT`
      };
    case "twelvesections":
      return {
        redirectLink: `/twelvesections/survey/${id}/results?step=REPORT`
      };
    case "360":
      return { redirectLink: `/360/survey/${id}/results?step=REPORT` };
      
    default: {
      return { redirectLink: `/360/survey/${id}/results?step=REPORT` };
    }
  }
};
function CompletionMessage(props, type) {
  

  if (props.maxReached) {
    return (
      <Row className="survey_content_container">
        <Col md={{ span: 12, offset: 6 }} xs={24}>
          <Row gutter={16}>
            <Col md={24} style={{ marginBottom: "20px" }}>
              <h1 style={{ color: "#1abc9c" }}>
                {intl.maxReached[props.language]}
              </h1>
            </Col>
          </Row>
        </Col>
        <Col md={{ span: 16, offset: 4 }} xs={24}>
          <Button href={`survey`} type="primary" size="large">
            {intl.submitText[props.language]}
          </Button>
        </Col>
      </Row>
    );
  }
  if (props.peer) {
    return (
      <Row className="survey_content_container">
        <Col md={{ span: 12, offset: 6 }} xs={24}>
          <Row gutter={16}>
            <Col md={24} style={{ marginBottom: "20px" }}>
              <h1 style={{ color: "#1abc9c" }}>
                {intl.contributing[props.language]} {props.owner}
              </h1>
            </Col>
          </Row>
        </Col>
        <Col md={{ span: 16, offset: 4 }} xs={24}>
          <Button href={`/360/survey`} type="primary" size="large">
            {intl.submitText[props.language]}
          </Button>
        </Col>
      </Row>
    );
  }
  return (
    <Row className="survey_content_container">
      <Col md={{ span: 12, offset: 6 }} xs={24}>
        <Row gutter={16}>
          <Col md={24} style={{ marginBottom: "20px" }}>
            <h1 style={{ color: "#1abc9c" }}>{intl.allSet[props.language]}</h1>
          </Col>
        </Row>
      </Col>
      <Col md={{ span: 16, offset: 4 }} xs={24}>
        <Button
          href={getRedirectLink(type, props.evaluationId).redirectLink}
          type="primary"
          size="large"
          disabled={!props.evaluationId}
        >
          {!props.evaluationId
            ? intl.gotoResult.error[props.language]
            : intl.gotoResult.continue[props.language]}
        </Button>
      </Col>
    </Row>
  );
}

export default CompletionMessage;

CompletionMessage.defaultProps = {
  peer: false,
  maxReached: false
};



// WEBPACK FOOTER //
// ./src/pages/Evaluation/CompletionMessage.js